import request from '@/utils/request'



// 获取促销区列表
export function getPromoCategoryList() {

    return request({
        url: '/promoCategory/list',
        method: 'get',
    })
}

export function getSeckillProductList() {

    return request({
        url: '/product/seckillList',
        method: 'get',
    })
}


export function getProductDetail(detailId) {

    return request({
        url: '/product/' + detailId,
        method: 'get',
    })
}


export function confirmPay(detailId, orderId) {
    const data = { detailId: detailId, orderId: orderId }
    return request({
        url: '/mine/confirmGroupPurchasePay',
        method: 'post',
        data: data
    })
}

export function getGroupPurchaseList(detailId) {

    return request({
        url: '/product/groupPurchaseList/' + detailId,
        method: 'get',
    })
}

